import { addAsset } from './utilities';
// ===============================================================
// NEWSLETTER POPUP
// ===============================================================
export const NewsletterComponent = {
  root: document.querySelector('#component-popup-newsletter-root'),
  settings: window.popupNewsletterSettings || false,
  loaded: false,

  setPopupNewsletter: function () {
    const { settings, root } = NewsletterComponent;

    // Define propriedades do componente
    let maxWidth = settings.maxWidth;
    let imageUrl = settings.imageUrl;
    let title = settings.title;
    let description = settings.description;
    let subdomain = settings.subdomain;
    let successMessage = settings.success;

    // Inicia o componente
    const componentNewsletterPopup = new Vnda.Component.NewsletterPopup({
      maxWidth: maxWidth,
      maxHeight: 500,
      imageUrl: imageUrl,
      imagePosition: 'left',
      popupPosition: 'center',
      title: title,
      description: description,
      textBtnSubmit: 'Enviar',
      classBtnSubmit: 'button-newsletter',
      formKey: `${subdomain}-newsletter`,
      hasNameField: false,
      hasLastNameField: false,
      hasDateOfBirthField: false,
      hasPhoneField: false,
      successMessage: successMessage,
      delay: 500,
      frequency: '7',
      language: 'pt-BR',
    });

    // Renderiza o componente e marca como carregado
    componentNewsletterPopup.render(root);
    NewsletterComponent.loaded = true;
  },

  loadPopupNewsletter: function () {
    if (!NewsletterComponent.loaded) {
      const { settings } = NewsletterComponent;
      addAsset(settings.script, NewsletterComponent.setPopupNewsletter);
      addAsset(settings.styles);
    }
  },

  handlePopupInputs: function (selector) {
    var observer = new MutationObserver(function (mutations) {
      // Popup aberto
      if (document.querySelector(selector)) {
        const inputEmail = document.querySelector(`${selector} input[name="email"]`);
        const inputPhone = document.querySelector(`${selector} input[name="phone"]`);
        const inputDateOfBirth = document.querySelector(`${selector} input[name="dateOfBirth"]`);

        if (inputEmail) {
          inputEmail.placeholder = 'Informe seu e-mail';
        }

        if (inputDateOfBirth) {
          const inputDateOfBirthTitle = inputDateOfBirth.parentElement.querySelector('p');
          if (inputDateOfBirthTitle) {
            inputDateOfBirthTitle.innerText = 'Data do seu aniversário';
          }
        }

        if (inputPhone) {
          inputPhone.placeholder = '(XX) XXXXX-XXXX';

          inputPhone &&
            inputPhone.addEventListener('input', (e) => {
              //(XX) XXXXX-XXXX
              var phoneValue = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
              e.target.value = !phoneValue[2]
                ? phoneValue[1]
                : '(' + phoneValue[1] + ') ' + phoneValue[2] + (phoneValue[3] ? '-' + phoneValue[3] : '');
            });
        }

        observer.disconnect();

        // Observa envio/mudanças no formulário
        // Quando ocorre o envio, os elementos internos recebem alterações
        const observerPopup = new MutationObserver(function (mutations) {
          // O elemento que recebe a mutação é o formulário
          // Caminho necessário para chegar na div principal
          const popupSection = mutations[0].target.parentElement.parentElement.parentElement;
          popupSection.classList.add('-updated');
          observerPopup.disconnect();
        });

        observerPopup.observe(document.querySelector('form.cmp-newsletter-popup-2xAs6q-U517OsmRyLtvFtq'), {
          childList: true,
          subtree: true,
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },

  init: function () {
    const { root, settings, handlePopupInputs, loadPopupNewsletter } = this;

    if (!root || !settings) return;

    const eventType = window.innerWidth <= 1024 ? 'scroll' : 'mousemove';
    window.addEventListener(
      eventType,
      () => {
        loadPopupNewsletter();
        handlePopupInputs('.cmp-newsletter-popup-section');
      },
      { once: true }
    );
  },
};

// ===============================================================
// PREÇO
// ===============================================================
// Carrega o componente de preço quando um product-block ou product-infos entra em tela
export const PriceComponent = {
  script: window.priceComponent || false,
  loaded: false,

  init: function () {
    if (!PriceComponent.script) return;

    const productContainers = document.querySelectorAll('[data-product-box]');

    if (productContainers.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            if (!PriceComponent.loaded) {
              addAsset(PriceComponent.script);
              PriceComponent.loaded = true;
            }
            observer.disconnect();
            break;
          }
        }
      },
      { threshold: 0.1 }
    );

    productContainers.forEach((product) => {
      observer.observe(product);
    });
  },
};
